import { GrayColors, SolutionColorVariables } from "@smartsuite/react-ui";
import styled from "styled-components";

export const StyledInfoButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  border-radius: 5px;
  background-color: ${GrayColors["G-1"]};
  cursor: pointer;
  transition: background-color 200ms ease-in;

  &:hover {
    transition: background-color 200ms ease-out;
    svg {
      path {
        fill: ${SolutionColorVariables.sc3};
      }
    }
  }
`;
